import { validateCmsStream } from './services';
import { NikeCmsMarkdownModules } from '../../types/generated/nike-cms-markdown-modules';
import { useCallback, useEffect, useState } from 'react';

export type StreamingModuleState =
    | { value: 'VALIDATING' }
    | { value: 'VALID' }
    | { value: 'INVALID'; code: string; params?: [] | {} };

export const useStreamingModule = ({
    url,
    type,
    provider,
    matchId,
    sport,
    sportId,
    startTime,
    restriction,
    introPeriod,
    tournamentId
}: NikeCmsMarkdownModules.StreamingModule) => {
    const [moduleState, setModuleState] = useState<StreamingModuleState>({ value: 'VALIDATING' });
    const [restarter, setRestarter] = useState(0);
    const [stream, setStream] = useState(null);

    useEffect(() => {
        validateCmsStream({ provider, restriction, introPeriod, tournamentId })
            .then(response => {
                if (response.errorCode) {
                    return setModuleState({
                        value: 'INVALID',
                        code: response.errorCode,
                        params: response.errorParams
                    });
                }
                setModuleState({ value: 'VALID' });
                setStream({ expirationIntroDate: response?.expirationIntroDate });
            })
            .catch(() => {
                setModuleState({ value: 'INVALID', code: 'UNKNOWN_ERROR' });
            });
    }, [provider, restriction, introPeriod, restarter, matchId, tournamentId]);

    const onRestart = useCallback(() => {
        setRestarter(restarter + 1);
        setModuleState({ value: 'VALIDATING' });
    }, [restarter]);

    return {
        url,
        type,
        provider,
        matchId,
        sport,
        sportId: isNaN(parseInt(sportId)) ? 0 : parseInt(sportId),
        startTime,
        restriction,
        introPeriod,
        tournamentId,
        moduleState,
        onRestart,
        stream
    };
};
